import React, {
  useCallback, useContext, useState
} from 'react';

import { useIndex } from '../../hooks';
import { AuthUserContext } from '../auth-component';
import { ButtonBar } from '../basic-inputs';

import { AddPersonOption } from './add-person-option';

import { ModalFormHeader, PersonSelectOption } from '.';

interface PersonMultiSelectProps {
  selected: any[];
  handleSelectOptions: (selected: any[]) => void;
  handleClickableOption: () => void;
  multiple?: boolean;
  handleCancel: () => void;
  inModal?: boolean;
}

export function PersonMultiSelect({
  selected,
  handleSelectOptions,
  handleClickableOption,
  multiple = false,
  handleCancel,
  inModal = false
}: PersonMultiSelectProps) {
  const { user } = useContext(AuthUserContext);
  
  const { data: people } = useIndex('people', { user_id: user?.id });
  const [ selectedPeople, setSelectedPeople ] = useState([]);

  const handleDone = useCallback(() => {
    handleSelectOptions([ ...selectedPeople, ...selected ]);
    setSelectedPeople([]);
    handleCancel();
  }, [ handleCancel, handleSelectOptions, selected, selectedPeople ]);

  const handleClick = useCallback((person) => {
    console.log('handleClick', person);
    const isSelected = selectedPeople.some((p) => p.id === person.id);

    if (!isSelected) {
      if (multiple) {
        setSelectedPeople((prev) => [ ...prev, person ]);
      } else {
        setSelectedPeople([ person ]);
      }
    } else {
      if (multiple) {
        setSelectedPeople((prev) => prev.filter((p) => p.id !== person.id));
      } else {
        setSelectedPeople([]);
      }
    }
  }, [ multiple, selectedPeople ]);

  // TODO: prevent backend from letting user select themselves
  const potentialOptions = people
    .filter(
      person => person.linkedUserId !== user?.id
    );

  const availableOptions = potentialOptions
    .filter(
      (person) => !selected.some((p) => p.id === person.id)
    );

  const classes = [ 'person-multi-select' ];
  if (inModal) {
    classes.push('modal-form-container');
  } else {
    classes.push('form-container');
  }

  return (
    <div className={classes.join(' ')}>
      <ModalFormHeader
        icon="group"
        header="Select People"
      />
      {availableOptions.map((person) => (
        <PersonSelectOption
          key={person.id}
          id={person.id}
          text={`${person.firstName} ${person.lastName}`}
          relationship={person.relationship ?? 'not specified'}
          handleClick={() => handleClick(person)}
          selected={selectedPeople.some((p) => p.id === person.id)}
        />
      ))}
      <div style={{ height: 0, border: 'solid 1px cornflowerblue' }}></div>
      <AddPersonOption
        icon="person_add"
        text="Add a new person"
        handleClick={handleClickableOption}
      />
      <ButtonBar
        handlePrimary={handleDone}
        primaryText="Done"
        handleSecondary={handleCancel}
        secondaryText="Cancel"
      />
    </div>
  );
}
